<template lang="pug">
  .bg-white.overflow-hidden
    .h-100vh.overflow-y-scroll.hide-scrollbar(ref="scrollBody")
      transition(name="fade")
        .p2.pb5.flex.flex-wrap(v-if="loadImgs")
          figure.p1(v-for="(image, index) in activeImages", @mouseenter="showHoverIndex(index)", @mouseleave="hoverIndexVisible = false")
            thumb.cursor-pointer(:image="image", @click="$emit('thumbClick', image.url)")
            //- .bg-ltgray.cursor-pointer(@click="$emit('thumbClick', image.url)")
              img.block(:src="image.url", :alt="image.alt")
    footer.absolute.h-4.bottom-0.w-100.cols.px3.items-center.bg-white
      .col
        close-icon.cursor-pointer(style="width:1rem;height:1rem;", @click="$emit('close')")
      .col.center
        active-title(:project="activeProject")
      .col.right-align
        span(v-show="hoverIndexVisible") {{hoverIndex}}/
        span {{activeImages.length}}
</template>

<script>
import Thumb from './SeriesViewer__ThumbsView__Thumb'
import ActiveTitle from '@/components/SeriesViewerFooter__ActiveTitle'
import CloseIcon from '@/components/SVG-X'
export default {
  name: 'Viewer__ThumbsView',
  inheritAttrs: false,
  props: ['allImages', 'activeProject', 'visible'],
  components: { Thumb, ActiveTitle, CloseIcon },
  data () {
    return {
      loadImgs: false,
      hoverIndex: -1,
      hoverIndexVisible: false
    }
  },
  computed: {
    activeImages () {
      return this.allImages.filter(img => img.id === this.activeProject.id)
    }
  },
  watch: {
    visible (visible) {
      this.loadImgs = true
      if (visible) this.$refs.scrollBody.scrollTo(0, 0)
    }
  },
  methods: {
    showHoverIndex (index) {
      this.hoverIndexVisible = true
      this.hoverIndex = index + 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SeriesViewer__ThumbsView.vue